export const SPECIAL_PROJECT_TYPE = 'adhesion_map';

export type TSpecialProjectTemplateContext = {
  type: typeof SPECIAL_PROJECT_TYPE;
  url: string;
  image: string;
  logoImageUrl: string;
  title: string;
  description: string;
  annotation?: string;
  label?: string;
  objectId?: string;
  dealType?: string;
  objectType?: string;
};

export type TOwnTemplateContext = TSpecialProjectTemplateContext;
